export function historySlider() {
  if (!window.FarloUI) window.FarloUI = {};
  const instanceMap = new WeakMap();

  function parseOptions(el) {
    const raw = el.getAttribute('data-flickity');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e1) {
      const start = raw.indexOf('{');
      const end = raw.lastIndexOf('}');
      if (start !== -1 && end !== -1 && end > start) {
        try { return JSON.parse(raw.slice(start, end + 1)); } catch (e2) {}
      }
      console.warn('[FarloUI] Invalid data-flickity JSON on element:', el, e1, raw);
      return {};
    }
  }

  function initElement(el) {
    if (!el) return null;

    if (window.Flickity && typeof window.Flickity.data === 'function') {
      const existing = window.Flickity.data(el);
      if (existing) {
        instanceMap.set(el, existing);
        return existing;
      }
    }
    if (instanceMap.has(el)) return instanceMap.get(el);

    if (typeof window.Flickity !== 'function') {
      console.error('[FarloUI] Flickity not found. Make sure enqueued before this script.');
      return null;
    }

    const opts = parseOptions(el);

    if (opts.asNavFor && el.classList.contains('history-slider__main')) {
      delete opts.asNavFor;
    }

    const flkty = new window.Flickity(el, opts);

    if (opts.imagesLoaded && typeof flkty.resize === 'function') {
      flkty.on('imagesLoaded', function () { flkty.resize(); });
      window.addEventListener('load', function () { try { flkty.resize(); } catch(e) {} });
    }

    instanceMap.set(el, flkty);
    return flkty;
  }

  function initFlickity(root) {
    const scope = root instanceof Element ? root : document;
    const nodes = Array.from(scope.querySelectorAll('.js-flickity'));

    nodes.sort((a, b) => {
      const aIsMain = a.classList.contains('history-slider__main');
      const bIsMain = b.classList.contains('history-slider__main');
      const aIsNav  = a.classList.contains('history-slider__nav');
      const bIsNav  = b.classList.contains('history-slider__nav');

      if (aIsMain && !bIsMain) return -1;
      if (bIsMain && !aIsMain) return 1;
      if (aIsNav && !bIsNav) return 1;
      if (bIsNav && !aIsNav) return -1;
      return 0;
    });

    const instances = [];
    nodes.forEach((el) => {
      const inst = initElement(el);
      if (inst) instances.push(inst);
    });
    return instances;
  }

  window.FarloUI.initFlickity = initFlickity;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFlickity(document); });
  } else {
    initFlickity(document);
  }

  try {
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((n) => {
          if (!(n instanceof Element)) return;
          if (n.matches && n.matches('.js-flickity')) {
            initElement(n);
          } else {
            n.querySelectorAll?.('.js-flickity').forEach((el) => initElement(el));
          }
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {
  }

  if (window.acf && typeof window.acf.addAction === 'function') {
    window.acf.addAction('render_block_preview/type=history-slider-block', function ($el) {
      const node = $el && $el[0] ? $el[0] : null;
      if (node) initFlickity(node);
    });
  }
}
